module.exports = __webpack_public_path__ + "img/totally-radio-70s.13d335aa.png";